import { useMutation, useQueryClient } from 'react-query';
import { getTemporaryImageUrlFromPublicUrl } from 'services/DefaultService';
import { deleteRecognitionAsync, getAllRecognitionsByLicenseAsync } from '../../index';
import { RECOGNITION_KEYS } from '../useQuery';

/**
 * @deprecated
 * Este hook genérico será removido no futuro. 
 * Ao invés de usá-lo, utilize os hooks de domínio específicos (ex: useDeleteStudentMutation, useDeleteResponsibleMutation).
 * Eles garantem a limpeza correta do cache dos Dropdowns.
 */
export const useDeleteRecognitionAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteRecognitionAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([RECOGNITION_KEYS.ALL]);
    },
  });
};

export const useGetAllRecognitionsByLicenseAsync = () =>
  useMutation(getAllRecognitionsByLicenseAsync);

export const useLoadFirebaseImageMutation = () => {
    return useMutation((publicUrl: string) =>
      getTemporaryImageUrlFromPublicUrl(publicUrl),
    );
  };